require("jquery");
require("jquery-ui-dist/jquery-ui.min.js");
import "./script.js";
import "./pageEdit/index.js";
import "./pageAccount.js";
import "./pageTop.js";
import "./analytics.js";
import "./flashMessage.js";
